module.exports = __webpack_public_path__ + "static/media/Drive 1000*1500.48c89e69.jpg";